import NValidation from './NValidation.vue';

export default NValidation;